export function isPageReloaded(): boolean | undefined {
	// In case browser does not support Performance API
	if (!window.performance) return undefined;

	const navigationTiming = performance.getEntriesByType(
		'navigation',
	)[0] as PerformanceNavigationTiming;

	return navigationTiming.type === 'reload';
}
